import React, {useState} from "react";
import {useSelector} from "react-redux";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";

//components:
import TracksTable from "./Table";
import {CircularProgress} from "@material-ui/core";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded";
import {CreateTrackModal} from "../../../widgets";

const TracksTableCard = ({isLoading = true, tracksError = {}}) => {
    const {t} = useTranslation();
    //redux:
    //store:
    const {settingsTracks = []} = useSelector(state => state.settings);

    const tracksWithNoSpecial = settingsTracks.filter(track => !track.isSpecial);

    //local state:
    const [showCreateTrackModal, setShowCreateTrackModal] = useState(false);

    return (
        <div className="col-12 col-md-9">
            <div className="card card-custom gutter-b shadow">
                <div className="card-header flex-wrap pt-6 pb-0 border-bottom border-gray justify-content-between">
                    <div className="card-title">{t("ADMINPANEL.TRACKS.TITLE")}</div>
                    <div className="card-title my-0">
                        {t("ADMINPANEL.TRACKS.ADD")}
                        <button
                            type="button"
                            className="btn btn-icon btn-light px-3 ml-3 add_track font-size-base"
                            disabled={isLoading}
                            onClick={() => {
                                setShowCreateTrackModal(true);
                            }}
                        >
                            <AddCircleRoundedIcon color="secondary" />
                        </button>
                    </div>
                </div>
                <div className="card-body position-relative min-h-180px">
                    <div
                        className="d-flex flex-column justify-content-center"
                        style={{
                            zIndex: !isLoading ? 1 : -1,
                            opacity: !isLoading ? 1 : 0,
                            transition: "0.4s ease all",
                        }}
                    >
                        {tracksError?.text ? (
                            <div
                                className={`alert alert-${tracksError.type ||
                                    "warning"} font-weight-bold w-fit-content d-flex align-items-center`}
                            >
                                <WarningRoundedIcon color="inherit" className="mr-5" />
                                {tracksError.text}
                            </div>
                        ) : null}

                        <TracksTable t={t} tracks={tracksWithNoSpecial} />
                    </div>

                    {isLoading ? (
                        <div className="d-flex justify-content-center align-items-center position-absolute top-0 left-0 w-100 h-100 bg-transparent">
                            <CircularProgress />
                        </div>
                    ) : null}

                    {/* create track modal */}
                    <CreateTrackModal
                        tracks={tracksWithNoSpecial}
                        open={showCreateTrackModal}
                        setOpen={setShowCreateTrackModal}
                    />
                </div>
            </div>
        </div>
    );
};

TracksTableCard.propTypes = {
    isLoading: PropTypes.bool,
    tracksError: PropTypes.object,
};

export default TracksTableCard;
